import { render, staticRenderFns } from "./VldSceme.vue?vue&type=template&id=4c4cfc24&scoped=true&"
import script from "./VldSceme.vue?vue&type=script&lang=js&"
export * from "./VldSceme.vue?vue&type=script&lang=js&"
import style0 from "./VldSceme.vue?vue&type=style&index=0&id=4c4cfc24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c4cfc24",
  null
  
)

export default component.exports